<div [ngClass]="subComment ? 'subComment' : 'comment'">
  <div class="author-name">
    {{ comment.user === null ? '???' : comment.user.username }}
  </div>
  <div class="creation-date">
    {{
      createdAt
        | feedDate
          : translate.currentLang
          : (settings$ | async)?.default_date_format
    }}
  </div>
  <img
    class="author-avatar"
    [src]="comment.user === null ? 'null' : comment.user.avatar_url"
    alt="autor avatar" />
  <div class="body">{{ comment.body }}</div>

  <div class="bottom-cont">
    @if (!subComment) {
      <span class="clickable" (click)="replyClick()" translate
        >watch.comment_modal.reply_btn</span
      >
    }
    @if (displaySubComment && (replyCount | async) > 0) {
      <span class="clickable" (click)="getSubComment()" translate=""
        >watch.comment_modal.hide_more_reply_btn</span
      >
    }
    @if (!displaySubComment && (replyCount | async) > 0) {
      <span class="clickable" (click)="getSubComment()">
        {{ more_reply_btn }}
      </span>
    }
  </div>

  <div class="action-btn" (click)="onActionBtnClick()">
    <span class="icon icon-more"></span>
  </div>
  @if (isActionClick) {
    <div class="action-select">
      <!-- <div Ripple *ngIf="user.id === comment.user.id" class="action-select-item" class="action-select-item" translate>
            <span class="icon icon-new-edit"></span>watch.comment_modal.action-btn.update_comment</div> -->
      @if (user.id === comment.user.id) {
        <div
          pRipple
          class="action-select-item"
          (click)="deleteComment()"
          translate>
          <span class="icon icon-poubelle"></span
          >watch.comment_modal.action-btn.delete_comment
        </div>
      }
      @if (user.id !== comment.user.id) {
        <div
          pRipple
          (click)="onReportCommentClick()"
          class="action-select-item"
          translate>
          <span class="icon icon-new-warning"></span
          >watch.comment_modal.action-btn.report_comment
        </div>
      }
    </div>
  }
</div>

@if (replying) {
  <div class="comment-input">
    <img class="user-logged-avatar" [src]="user.avatar_url" alt="" />
    <app-input-comment
      (send)="sendReply($event)"
      [placeholder]="'dashboard.popup-comments.your-comment' | translate"
      [taggable]="false" />
  </div>
}
